module.exports = __webpack_public_path__ + "static/media/gears_blue.c8dc903a.svg";